import React, { useState, useEffect } from 'react';
import LogoLoader from './LogoLoader';
import s from './FullscreenLoader.scss';

function FullscreenLoader({ message, variant = 'home' }) {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const wittyMessages = [
    'Brewing some pixel-perfect magic...',
    'Teaching pixels to dance...',
    'Compiling creativity...',
    'Loading awesomeness...',
    'Summoning the design gods...',
    'Charging the flux capacitor...',
    'Herding the digital cats...',
    'Waking up the hamsters...',
  ];

  // Rotate messages every 3.5 seconds
  useEffect(() => {
    if (!!message) return; // if only one message is provided, don't rotate messages
    const interval = setInterval(() => {
      setIsTransitioning(true);

      setTimeout(() => {
        setCurrentMessageIndex(
          (prevIndex) => (prevIndex + 1) % wittyMessages.length
        );

        setTimeout(() => {
          setIsTransitioning(false);
        }, 150); // Gap where no message is shown
      }, 500); // Full fade-out duration
    }, 3500);

    return () => clearInterval(interval);
  }, [wittyMessages.length, message]);

  const displayMessage = message || wittyMessages[currentMessageIndex];

  return (
    <div className={`${s.fullscreenLoader} ${s[variant]}`}>
      <div className={s.spinnerContainer}>
        <LogoLoader size="large" />
        <div className={s.messageContainer}>
          <span
            className={`${s.loadingMessage} ${
              isTransitioning ? s.fadeOut : s.fadeIn
            }`}
          >
            {displayMessage}
          </span>
        </div>
      </div>
    </div>
  );
}

export default FullscreenLoader;
